import React, { useState, useEffect, useContext } from 'react';
import { apiUrl, myHeaders_Auth_With_Cache_Control } from 'Api/Api';
import axios from 'axios';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import AddEditModal from 'components/Modals/AddEditTeamModal';

import UserContext from 'store/UserContext';

function PechaKuchaTeams() {
  const user_context = useContext(UserContext);
  
  const [activeTeams, setActiveTeams] = useState();
  const [inactiveTeams, setInactiveTeams] = useState();
  const [show, setShow] = useState(false);
  const [editableTeam, setEditableTeam] = useState();

  //gets ACTIVE teams
  async function getActiveTeams() {
    const response = await axios.get(
      `${apiUrl}organizations?status_code=1`,
      myHeaders_Auth_With_Cache_Control
    );
    console.log('ACTIVE TEAMS', response);
    let unsorted = response.data.entities;
    let sortedActiveTeams = unsorted.sort((a, b) => {
      return a.entity_name.localeCompare(b.entity_name);
    });
    return sortedActiveTeams;
  }
  //gets INACTIVE teams
  async function getInactiveTeams() {
    const response = await axios.get(
      `${apiUrl}organizations?status_code=2`,
      myHeaders_Auth_With_Cache_Control
    );
    console.log('INACTIVE TEAMS', response);
    let unsorted = response.data.entities;
    let sortedInactiveTeams = unsorted.sort((a, b) => {
      return a.entity_name.localeCompare(b.entity_name);
    });
    return sortedInactiveTeams;
  }

  useEffect(() => {
    if (!activeTeams || !inactiveTeams) {
      (async () => {
        try {
          setActiveTeams(await getActiveTeams());
          setInactiveTeams(await getInactiveTeams());
        } catch (err) {
          console.log('Something went wrong', err);
        }
      })();
    }
  });

  async function handleClose() {
    setShow(false);
    setEditableTeam();
    setActiveTeams(await getActiveTeams());
    setInactiveTeams(await getInactiveTeams());
  }
  function handleShow(teaminfo) {
    setShow(true);
    setEditableTeam(teaminfo);
  }

  return (
    <React.Fragment>
      <Container>
        <Row className="my-3 justify-content-between">
          <Col xs={8}>
            <h1>Teams Page</h1>
          </Col>
          <Col xs={2}>
            <Button variant="pkprimary" onClick={handleShow}>
              Add Team
            </Button>
          </Col>
        </Row>
        <Row>
          <h3 className="bg-success text-white p-3 mt-3 col-12">
            Active Teams
          </h3>
          {!activeTeams ? (
            <ActivityIndicator />
          ) : (
            activeTeams.map((team, index) => (
              <Col md={4} className="my-2 gx-0" key={index}>
                <Card
                  bg={user_context.theme}
                  text={user_context.theme === 'light' ? 'dark' : 'white'}
                >
                  <Card.Header>
                    <Row>
                      <Col xs={8}>
                        <h4>{team.entity_name}</h4>
                      </Col>
                      <Col xs={2}>
                        <Button
                          variant="pkprimary"
                          onClick={() => handleShow(team)}>
                          Edit Team
                        </Button>
                      </Col>
                    </Row>
                  </Card.Header>
                  <Card.Body>
                    <Card.Text>{team.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))
          )}
        </Row>
        <Row>
          <h3 className="bg-danger text-white p-3 mt-3 col-12">
            Inactive Teams
          </h3>

          {!inactiveTeams ? (
            <ActivityIndicator />
          ) : (
            inactiveTeams.map((team, index) => (
              <Col md={4} className="my-2 gx-0" key={index}>
                <Card
                  bg={user_context.theme}
                  text={user_context.theme === 'light' ? 'dark' : 'white'}
                >
                  <Card.Header>
                    <Row>
                      <Col xs={8}>
                        <h4>{team.entity_name}</h4>
                      </Col>
                      <Col xs={2}>
                        <Button
                          variant="pkprimary"
                          onClick={() => handleShow(team)}>
                          Edit Team
                        </Button>
                      </Col>
                    </Row>
                  </Card.Header>
                  <Card.Body>
                    <Card.Text>{team.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))
          )}
        </Row>
      </Container>
      {editableTeam ? (
        <AddEditModal
          teamInfo={editableTeam}
          show={show}
          handleClose={() => handleClose()}
          // getActiveTeams={getActiveTeams}
          // getInactiveTeams={getInactiveTeams}
        />
      ) : null}
    </React.Fragment>
  );
}

export default PechaKuchaTeams;
